import { useEffect, useState } from 'react';

import { getPerformance } from '../../api';
import { hasAccess, ROLE_ADMIN, ROLE_CARRIER } from '../../utils/access';

import { getSeparateValues, getCumulativeValues } from './helpers';

export const usePerformanceData = (filters = {}) => {
  const [data, updateData] = useState([]);
  const [loading, updateLoading] = useState(false);

  useEffect(() => {
    const getAll = async () => {
      if (hasAccess([ROLE_ADMIN])) {
        if (filters && filters.partyType) {
          const { carrier, operator, partyType } = filters;
          const partyCode = partyType.value === ROLE_CARRIER ? carrier.value : operator.value;
          updateLoading(true);
          const response = await getPerformance(partyType.value, partyCode);
          updateLoading(false);

          if (!response) {
            return;
          }

          updateData(response.map(item => ({ ...item, originalCount: item.alaLevelsCount })));
        }
      } else {
        updateLoading(true);
        const response = await getPerformance();
        updateLoading(false);

        if (!response) {
          return;
        }

        updateData(response.map(item => ({ ...item, originalCount: item.alaLevelsCount })));
      }
    };

    getAll();
  }, [filters]);

  return [data, updateData, loading];
};

export const usePerformance = (type, loadedOptions) => {
  const [data, updateData, loading] = usePerformanceData(loadedOptions);

  useEffect(() => {
    if (type === 'separate') {
      updateData(getSeparateValues(data));
    } else {
      updateData(getCumulativeValues(data));
    }
  }, [type]);

  return [data, loading];
};
